(async function () {
    const res = await fetch("/manifest.json");
    const manifest = await res.json();
    const script = document.createElement("script");
    const file = manifest["app.js"];
    script.src = file.startsWith("/") ? file : `/${file}`;
    script.type = "module";
    document.body.appendChild(script);
})();
